const destinationColorId = {
  Grand: 100,
  World: 101
};

export function getSpecialVoyageDestinationIdFromComboType(
  comboType: string | undefined | null
): number | undefined {
  if (!comboType) return undefined;
  return destinationColorId[comboType];
}

export function getDestinationNameFromComboType(
  comboType: string | undefined | null
): string | undefined {
  if (!comboType) return undefined;
  return comboType == "World" ? "World Cruises" : "Grand Voyages";
}
